import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendAPI } from '@core/models/backend-api';
import { ServicesResponse } from '@core/models/services-response';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})

// Sorry for the name...
export class ServiceService {

	constructor (private http: HttpClient) { }

	getServices(packageId: string, startYear: number, startMonth: number, monthCount: number): Observable<ServicesResponse> {
		const url = BackendAPI.staticDataServices;

		const requestParams = new HttpParams()
			.set("packageId", packageId)
			.set("startYear", startYear)
			.set("startMonth", startMonth)
			.set("monthCount", monthCount);

		return this.http.get<ServicesResponse>(url, { params: requestParams });
	}
}
